<h3 mat-dialog-title>{{ title }}</h3>
<mat-dialog-content>
    <p>{{ text }}</p>
</mat-dialog-content>
<mat-dialog-actions class="actions-corners">
    <button mat-button color="primary" (click)="onCancelClick()">Abbrechen</button>
    <button mat-raised-button color="primary" (click)="confirmDelete()">{{ textButton }}</button>
</mat-dialog-actions>
